import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottomFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutBottomFull"><Path d="M3 13.5V3H21V13.5L3 13.5Z" fill="currentColor"/><Path d="M3 15V21H21V15L3 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottomFull;
